import React, { Component } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

class ErrorNotification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      message: '',
      severity: 'error'
    };
  }

  componentDidMount() {
    // Setze globale Funktion zum Anzeigen von Fehlermeldungen
    window.showErrorNotification = (message, severity = 'error') => {
      this.setState({
        open: true,
        message: message,
        severity: severity
      });
    };
  }

  componentWillUnmount() {
    // Entferne globale Funktion
    delete window.showErrorNotification;
  }

  handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({ open: false });
  };

  render() {
    return (
      <Snackbar
        open={this.state.open}
        autoHideDuration={6000}
        onClose={this.handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert 
          onClose={this.handleClose} 
          severity={this.state.severity}
          variant="filled"
          action={
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={this.handleClose}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          }
          sx={{ width: '100%' }}
        >
          {this.state.message}
        </Alert>
      </Snackbar>
    );
  }
}

export default ErrorNotification;
